import { render, staticRenderFns } from "./selectAjax.vue?vue&type=template&id=50b68214"
import script from "./selectAjax.vue?vue&type=script&lang=ts"
export * from "./selectAjax.vue?vue&type=script&lang=ts"
import style0 from "./selectAjax.vue?vue&type=style&index=0&id=50b68214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports